import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import '../report.css';
import ApiService from '../../../../services/apiService';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import '../saleReport/table.css';
import ReportCard from '../reportCard/reportCard';

const CustomerOrderReport = () => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    fromDate: '',
    toDate: '',
  });

  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('FromDate', formData?.fromDate);
      params.append('ToDate', formData?.toDate);
      const res = await apiService.getApiParamater('GET_CUST_REPORT', `?${params.toString()}`);
      setData(res?.data?.result || []);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-lg-5">
      <div className="px-lg-5">
        <div className="row">
          <div className="col">
            <label htmlFor="validationCustom01" className="form-label">
              From Date
            </label>
            <input type="datetime-local" className="form-control" value={formData?.fromDate} onChange={handleInputChange} name="fromDate" />
          </div>
          <div className="col">
            <label htmlFor="validationCustom01" className="form-label">
              To Date
            </label>
            <input type="datetime-local" className="form-control" value={formData?.toDate} onChange={handleInputChange} name="toDate" />
          </div>

          <div className="col-2 mt-3">
            <button className=" mt-3 addItem-btn" type="submit" onClick={getReportData}>
              {t('search')}
            </button>
          </div>
        </div>
        <div className="pt-5">
          <div className="row">
            {data?.map((data) => (
              <div className="pt-5  col-6">
                <ReportCard data={data} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(CustomerOrderReport);
